/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupCommissionPercentApiRequest } from '../../models/hotel-edit-group-commission-percent-api-request';

export interface ApiHotelManageEditGroupCommissionPercentPost$Params {
      body: HotelEditGroupCommissionPercentApiRequest
}

export function apiHotelManageEditGroupCommissionPercentPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupCommissionPercentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupCommissionPercentPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupCommissionPercentPost.PATH = '/api/hotel/manage/edit/group/commission-percent';
